import React from 'react';
import styled from 'styled-components';

import { Flex, Box, Section, Typography, Loading } from 'components';
import { useModules } from 'features/modules';
import { Link } from 'react-router-dom';
import { createUrl } from 'app/utils';
import { useProducts } from 'features/products';
import { useContents } from 'features/contents';

interface ModulesHeaderProps {}

const SquareLines = styled('i')`
  position: relative;
  position: absolute;
  left: 0;
  width: 0px;
  height: 0px;

  &::after {
    content: '';
    display: block;
    background-color: ${({ theme }) => theme.colors.primary_200};
    position: absolute;
    z-index: 1000;
  }

  &::before {
    content: '';
    display: block;

    border-top: 2px solid ${({ theme }) => theme.colors.dark_150};
    border-right: 2px solid ${({ theme }) => theme.colors.dark_150};
    position: absolute;

    right: 0px;
    z-index: 1;
  }

  ${({ theme: { mediaQueries } }) => {
    return `
    ${mediaQueries.mobile} {
      top: 1px;
      left: -25px;

      &::after {
        width: 14px;
        height: 14px;
      }

      &::before {
        top: -30px;
        width: 150px;
        height: 230px;
      }
    }

    ${mediaQueries.tablet} {
      left: -35px;

      &::after {
        width: 18px;
        height: 18px;
        top: -2px;
        left: -2px;
      }

      &::before {
        top: -40px;
        width: 300px;
        height: 300px;
      }
    }

    ${mediaQueries.desktop} {
      top: 4px;
      left: -45px;

      &::after {
        width: 24px;
        height: 24px;
        top: -3px;
        left: 0px;
      }

      &::before {
        top: -74px;
        width: 1300px;
        height: 350px;
      }
    }
  `;
  }}
`;

const Lines = styled('i')`
  display: block;

  border-top: 2px solid ${({ theme }) => theme.colors.dark_150};
  border-right: 2px solid ${({ theme }) => theme.colors.dark_150};
  position: absolute;
  z-index: 20;
  pointer-events: none;

  ${({ theme: { mediaQueries } }) => {
    return `
    ${mediaQueries.mobile} {
        top: -30px;
        right: -40px;
        width: 150px;
        height: 230px;
    }

    ${mediaQueries.tablet} {
        top: -40px;
        right: -30px;
        width: 300px;
        height: 300px;
    }

    ${mediaQueries.desktop} {
        right: -30px;
        top: -74px;
        width: 300px;
        height: 550px;
    }
  `;
  }}
`;

const ModulesHeader: React.FC<ModulesHeaderProps> = () => {
  const { moduleDetails } = useModules();
  const { productDetails } = useProducts();
  const { contentsList } = useContents();

  return moduleDetails && productDetails ? (
    <Flex minHeight={{ m: 200, t: 350, d: 500 }} flexGrow={0} bg="dark_350" flexDirection="column" justifyContent="space-between">
      <Flex flexGrow={0} mt={{ m: 30, t: 40, d: 70 }}>
        <Section flexGrow={0} position="relative">
          <Flex maxWidth="80%" flexDirection="column">
            <SquareLines />
            <Lines />
            <Link to={createUrl('productDetails', [productDetails.product.slug])}>
              <Typography type="type5" color="white" fontWeight="bold" upper>
                {productDetails.product.name}
              </Typography>
            </Link>

            <Typography as="h1" type="type11" color="white" fontWeight="bold" mt={{ m: 20, d: 25 }}>
              {moduleDetails.name}
            </Typography>
          </Flex>
        </Section>
      </Flex>

      <Section flexGrow={0} mb={{ m: 30, t: 40, d: 50 }} alignItems="center">
        <Box>
          <Typography type="type3" color="white25" upper>
            {`${contentsList.length} aula${contentsList.length === 1 ? '' : 's'}`}
          </Typography>
        </Box>
      </Section>
    </Flex>
  ) : (
    <Loading label="Por favor, aguarde." />
  );
};
export default ModulesHeader;
